import script from "./GuestItem.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestItem.vue?vue&type=script&setup=true&lang=js"

import "./GuestItem.vue?vue&type=style&index=0&id=de872842&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de872842"]])

export default __exports__